import { initClarity } from "services/clarity";
import { loadAppConfig } from "./loadConfig";

(async function bootstrap() {
  try {
    await loadAppConfig();

    initClarity();

    const React = (await import("react")).default;
    const ReactDOM = (await import("react-dom")).default;
    const App = (await import("./App")).default;

    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById("root")
    );
  } catch (error) {
    console.error("Erro no bootstrap:", error);
    const React = (await import("react")).default;
    const ReactDOM = (await import("react-dom")).default;
    ReactDOM.render(
      <div>Erro ao carregar configuração. Tente novamente mais tarde.</div>,
      document.getElementById("root")
    );
  }
})();
